import { useParams } from 'react-router-dom';
import BuyThankYouPresaleContainer from './BuyThankYouPresaleContainer';
import { ReportPaymentConnectorApollo } from '@front-activerse/common-components';

const BuyThankYouPresalePage = () => {
  const { token } = useParams();

  return (
    <ReportPaymentConnectorApollo>
      {({ reportPayment }) => {
        return <BuyThankYouPresaleContainer reportPayment={reportPayment} token={token} />;
      }}
    </ReportPaymentConnectorApollo>
  );
};

export default BuyThankYouPresalePage;
